import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import MultiSelectDropdown from '../../../../../../../../../../components/MultiSelectDropdown';
import { selectTagUsersToComment, tagUserToComment } from '../../../../../../../../../../redux/modules/activityLog';
import { hideModal } from '../../../../../../../../../../redux/modules/modal';

const ActivityLogTagCommentModal = ({ userChecklist }) => {
  const dispatch = useDispatch();
  const selectedUsers = useSelector(selectTagUsersToComment);

  return (
    <Box minWidth="350px" py={6}>
      <Text mb={4} textAlign="center" textStyle="bodySm">
        Tagging users will send them an email notification when you post this comment
      </Text>
      <Box mb={4}>
        <MultiSelectDropdown
          data={userChecklist}
          displayLength={1}
          idKey="id"
          labelKey="description"
          minWidth="350px"
          placeholder="Users"
          showLabel={false}
          values={selectedUsers}
          onChange={selected => {
            dispatch(tagUserToComment(selected));
          }}
        />
      </Box>
      <Button
        variant="primary"
        onClick={() => dispatch(hideModal())}
      >
        Apply
      </Button>
    </Box>
  );
};

ActivityLogTagCommentModal.propTypes = { userChecklist: PropTypes.arrayOf(PropTypes.shape({})) };

export default ActivityLogTagCommentModal;
